<template>
    <div class="automation-wizard-field-amount">
        <CompassFormItem v-bind="formItemProps" :error="field.currentError || ''">
            <CompassInput
                :value="localValue"
                type="number"
                :min="0"
                menuClass="automation-wizard-field-amount"
                @input="handleInput"
                @blur="handleBlur"
            >
                <template #suffix>
                    <span
                        class="automation-wizard-field-amount__suffix typographies-paragraph-medium-regular"
                    >
                        {{ currencySymbol }}
                    </span>
                </template>
            </CompassInput>
        </CompassFormItem>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: corpMapState } = createNamespacedHelpers('corp');

export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number],
            default: '',
        },
    },
    emits: ['update:value'],
    data() {
        return {
            localValue: this.value || '',
        };
    },
    computed: {
        ...corpMapState(['numformat']),
        formItemProps() {
            return {
                ...this.field.props?.formItem,
                label: this.field.props?.formItem?.label || '',
                required: this.field.required || false,
                requiredLabel:
                    this.field.props?.formItem?.requiredLabel ||
                    this.$t.__('common.labels.required'),
            };
        },
        currencySymbol() {
            return this.numformat?.currencysymbol || '€';
        },
    },
    watch: {
        value(newValue) {
            this.localValue = newValue || '';
        },
    },
    methods: {
        handleInput(event) {
            const inputValue = event.target.value;
            this.localValue = inputValue;
            this.$emit('update:value', String(inputValue));
        },
        handleBlur() {
            const num = Number(this.localValue);
            if (!isNaN(num) && this.localValue !== '') {
                const rounded = num.toFixed(2);
                this.localValue = rounded;
                this.$emit('update:value', String(rounded));
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-field-amount {
    &__suffix {
        color: var(--colors-common-text-standard-placeholder);
    }
}
</style>
